/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable prefer-rest-params */
import { Box } from "@mui/material";
import { FunctionComponent as F, useEffect, useRef } from "react";
import { timestampToSeconds } from "../../utils/string";
import { IValue } from "../Refs/RefsTable";
import SpielsTable from "../Refs/SpielsTable";



interface IProps
{
  videoId: string,
  record: IValue
}

const Rumble: F<IProps> = (props: IProps) =>
{
  const startSeconds = timestampToSeconds(props.record.startTime);
  const videoId = props.videoId;

  const rumble = ((r: any, u: any, m: any, b: any, l?: any, e?: any) =>
  {
    return r._Rumble  =b, r[b] || (r[b] = function()
    {
      (r[b]._=r[b]._||[]).push(arguments);

      if(r[b]._.length === 1)
      {
        l=u.createElement(m), e=u.getElementsByTagName(m)[0],
        l.async=1, l.src="https://rumble.com/embedJS/u4" +
        (arguments[1].video ? '.' + arguments[1].video : '')+ "/?url=" +
        encodeURIComponent(location.href) + "&args=" +
        encodeURIComponent(JSON.stringify([].slice.apply(arguments))),
        e.parentNode.insertBefore(l, e);
      }
    });
  })(window, document, "script", "Rumble");

  const rumblePlayerRef = useRef<HTMLIFrameElement | null>(null);

  useEffect(() =>
  {
    if(!rumblePlayerRef.current)
      return;

    rumble("play", { video: videoId, div: "rumble_" + videoId, api: (api: any) =>
    {
      // Start at ref time on first play only
      api.on('play', () =>
      {
        api.setCurrentTime(startSeconds);
        api.off('play');
      });
    } });
  }, []);


  return(
    <Box sx={{ display: 'flex' }}>
      <Box sx={{ display: 'flex' }}>
        <SpielsTable record={props.record}/>
      </Box>
      <Box sx={{ display: 'flex', textAlign: 'right' }}>
        <div id={"rumble_" + videoId} ref={rumblePlayerRef} />
      </Box>
    </Box>);
};

export default Rumble;
